import React from "react"
import { Link, Outlet, useParams } from "react-router-dom" 

export const ProjectDisplay = () => {
	return (
		<div>
			<Outlet/>
		</div>
	)
}
